var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictogramPlaneBrandNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.953 15.765L23.299 0.617",
    fill: "none",
    stroke: "#6322e5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.231,17.6l7.489,3.209a1.069,1.069,0,0,0,1.452-.7L23.48,1.18a.535.535,0,0,0-.769-.616L1.063,12.208a1.071,1.071,0,0,0,.086,1.927l3.8,1.63",
    fill: "none",
    stroke: "#6322e5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.953,15.765l2.6,7.2a.805.805,0,0,0,1.431.168l2.889-4.4",
    fill: "none",
    stroke: "#6322e5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.299 0.617L9.231 17.599 8.315 23.5",
    fill: "none",
    stroke: "#6322e5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramPlaneBrandNew);
export default __webpack_public_path__ + "static/media/pictogram-plane-brand-new.de017a8417f5f6c1aa1d207790819081.svg";
export { ForwardRef as ReactComponent };